import React, { useEffect } from "react";
import styled from "styled-components";
import { Images } from "../../../assets/images";

const EventConfirmation = ({ meta, contentRef, value, setValue }) => {
  const handleCopy = (event) => {
    const selectedText = window.getSelection().toString();
    if (!selectedText) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (meta?.speakerSettings?.length) {
      setValue(new Array(meta.speakerSettings.length).fill(""));
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meta?.speakerSettings]);

  const handleLinkChange = (index, newValue) => {
    const updatedLinks = [...value];
    updatedLinks[index] = newValue;
    setValue(updatedLinks);
  };

  return (
    <Container>
      <MainContainer style={{ width: "100%" }} ref={contentRef}>
        <EmailWrapper>
          <tbody>
            <EmailRow>
              <EmailCell>
                <EmailLogo src={Images.multicallLogo} alt="Left Logo" />
              </EmailCell>
              <EmailCell alignRight>
                <EmailLogo src={Images.companyLogo} alt="Right Logo" />
              </EmailCell>
            </EmailRow>
          </tbody>
        </EmailWrapper>
        <Row>
          <Header>Event Confirmation</Header>
        </Row>
        <Section>
          <p style={{ marginBottom: "10px" }}>
            <BoldText>{meta?.eventTitle}</BoldText> on {meta?.eventDate} at{" "}
            {meta?.eventTime}
          </p>
          <p>{meta?.coordinatorInfo?.coordinatorName},</p>
          <p>
            Thank you for choosing MultiCall. Please find the confirmation for
            the AGM below:
          </p>
        </Section>
        <Row>
          <Section green>Schedule</Section>
          <Section green>Coordinator</Section>
        </Row>
        <Content>
          <Column>
            <p>
              <BoldText>Event No:</BoldText> {meta?.eventId}
            </p>
            <p>
              <BoldText>Company Name:</BoldText> {meta?.orgName}
            </p>
            <p>
              <BoldText>Date:</BoldText> {meta?.eventDate} at {meta?.eventTime}{" "}
              for {meta?.eventDuration} hours
            </p>
            <p>
              <BoldText>Type:</BoldText> AGM
            </p>
          </Column>
          <Column>
            <p>
              <BoldText>Name:</BoldText>{" "}
              {meta?.coordinatorInfo?.coordinatorName
                ? meta?.coordinatorInfo?.coordinatorName
                : "-"}
            </p>
            <p>
              <BoldText>Phone:</BoldText>{" "}
              {meta?.coordinatorInfo?.coordinatorphone
                ? meta?.coordinatorInfo?.coordinatorphone
                : "-"}
            </p>
            <p>
              <BoldText>Email ID:</BoldText>{" "}
              {meta?.coordinatorInfo?.coordinatorEmail
                ? meta?.coordinatorInfo?.coordinatorEmail
                : "-"}
            </p>
            <p>
              <BoldText>Location:</BoldText>{" "}
              {meta?.coordinatorInfo?.coordinatorLocation
                ? meta?.coordinatorInfo?.coordinatorLocation
                : "-"}
            </p>
          </Column>
        </Content>
        <Row>
          <SectionTitle green>Important Links</SectionTitle>
        </Row>
        <TwoColumnSection>
          <Column>
            {meta?.advanceOptions?.micrositePrefix ? (
              <LinksContainer>
                <BoldText>Microsite Link:</BoldText>{" "}
                <StyledLink
                  href={meta?.advanceOptions?.micrositePrefix}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {meta?.advanceOptions?.micrositePrefix}
                </StyledLink>
              </LinksContainer>
            ) : (
              ""
            )}
            {meta?.eventUrl ? (
              <LinksContainer>
                <BoldText>Participant Link:</BoldText>{" "}
                <StyledLink
                  href={meta?.eventUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {meta?.eventUrl}
                </StyledLink>
              </LinksContainer>
            ) : (
              ""
            )}
          </Column>
          <Column>
            {meta?.eventTemplate === "AGM" ? (
              meta?.galleryView?.galleryViewUrl ? (
                <LinksContainer>
                  <BoldText>Gallery View Link:</BoldText>{" "}
                  <StyledLink
                    href={meta?.galleryView?.galleryViewUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {meta?.galleryView?.galleryViewUrl}
                  </StyledLink>
                </LinksContainer>
              ) : (
                <LinksContainer>
                  <BoldText>Gallery View Link:</BoldText>{" "}
                  <StyledLink
                    href={`https://digitalevents.in/events/gallery?eventId=${meta?.eventId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {`https://digitalevents.in/events/gallery?eventId=${meta?.eventId}`}
                  </StyledLink>
                </LinksContainer>
              )
            ) : (
              ""
            )}
          </Column>
        </TwoColumnSection>
        <Row>
          <Section green>Value Added Services</Section>
          <Section green>Reminders</Section>
        </Row>
        <TwoColumnSection>
          <Column>
            {meta?.livePageSettings?.textQuestion && (
              <p>
                <BoldText>Text Question: </BoldText> Yes
              </p>
            )}
            {meta?.livePageSettings?.videoQuestion && (
              <p>
                <BoldText>Video Question: </BoldText> Yes
              </p>
            )}
            {meta?.livePageSettings?.livePoll && (
              <p>
                <BoldText>Live Polls: </BoldText> Yes
              </p>
            )}
            {meta?.livePageSettings?.liveTickers && (
              <p>
                <BoldText>Live Ticker: </BoldText> Yes
              </p>
            )}
            {meta?.livePageSettings?.playbackRequired && (
              <p>
                <BoldText>Playback Info: </BoldText> Yes
              </p>
            )}
            <p>
              <BoldText>Custom Microsite: </BoldText>
              {meta?.advanceOptions?.micrositePrefix ? "Yes" : "No"}
            </p>
            <p>
              <BoldText>Social Media: </BoldText> MultiCall, YouTube, Facebook,
              Instagram, LinkedIn, Twitter
            </p>
          </Column>
          <Column>
            {meta?.reminders?.sms && (
              <p>
                <BoldText>SMS: </BoldText> Yes
              </p>
            )}
            {meta?.reminders?.email && (
              <p>
                <BoldText>Email: </BoldText> Yes
              </p>
            )}
            {meta?.reminders?.whatsApp && (
              <p>
                <BoldText>WhatsApp: </BoldText> Yes
              </p>
            )}
            <p>
              <BoldText>Voice Drop: </BoldText>{" "}
              {meta?.reminders?.voiceDrop ? "Yes" : "No"}
            </p>
            <p>
              <BoldText>Personal Invitation: </BoldText>{" "}
              {meta?.reminders?.individual ? "Yes" : "No"}
            </p>
          </Column>
        </TwoColumnSection>
        <Row>
          <SectionTitle green>Speaker Joining Information </SectionTitle>
        </Row>
        <SpeakersContainer>
          {meta?.speakerSettings?.length &&
          meta?.speakerSettings[0]?.speakerName
            ? meta.speakerSettings.map((speaker, index) => (
                <SpeakerCard key={index}>
                  <SpeakerInfo>
                    <p>
                      <strong>Speaker Name:</strong>{" "}
                      {speaker.speakerName || "N/A"}
                    </p>
                    <InputContainer>
                      <strong>Video Meeting Link:</strong>
                      <Input
                        placeholder="Enter link here"
                        type="text"
                        value={value[index] || ""}
                        onChange={(e) =>
                          handleLinkChange(index, e.target.value)
                        }
                        onCopy={handleCopy}
                      />
                    </InputContainer>
                  </SpeakerInfo>
                </SpeakerCard>
              ))
            : null}
        </SpeakersContainer>
        <Row>
          <SectionTitle green>
            Video Participant Joining Information
          </SectionTitle>
        </Row>
        <Row>
          <SectionTitle green>Event Configuration</SectionTitle>
        </Row>

        <TwoColumnSection>
          <Column>
            {meta?.eventSettings?.enableRegistration && (
              <p>
                <BoldText>Registrations:</BoldText> Yes
              </p>
            )}
            {meta?.eventSettings?.commonPassword && (
              <p>
                <BoldText>Common Password:</BoldText> Yes
              </p>
            )}
            {meta?.eventSettings?.enableLogins && (
              <p>
                <BoldText>Logins Required:</BoldText> Yes
              </p>
            )}
            {meta?.eventSettings?.singleUserSingleEntry && (
              <p>
                <BoldText>Single User Single Entry:</BoldText> Yes
              </p>
            )}
            {meta?.speakerSection?.speakersRequired && (
              <p>
                <BoldText>Speakers Section:</BoldText> Yes
              </p>
            )}
            <p>
              <BoldText>Speakers Visibility:</BoldText>{" "}
              {meta?.speakerSection?.speakersVisibility || "N/A"}
            </p>
          </Column>

          <Column>
            {meta?.eventSettings?.passwordRequired && (
              <p>
                <BoldText>Password Required:</BoldText> Yes
              </p>
            )}
            {meta?.eventSettings?.sendEmailDuringRegistration && (
              <p>
                <BoldText>Send Emails During Registration:</BoldText> Yes
              </p>
            )}
            <p>
              <BoldText>Pre-validate Registrations:</BoldText>{" "}
              {meta?.preValidateUsers?.preValidateLabel || "N/A"}
            </p>
            {meta?.resourceSection?.resourcesRequired && (
              <p>
                <BoldText>Resources Section:</BoldText> Yes
              </p>
            )}
            <p>
              <BoldText>Content Format:</BoldText>{" "}
              {meta?.livePageSettings?.contentFormat || "-"}
            </p>
          </Column>
        </TwoColumnSection>
        <Row>
          <SectionTitle green>Operator Script</SectionTitle>
        </Row>
        <Content>
          <Column>
            <Text>Regards</Text>
            <Text>
              <strong>{meta?.eventManageName || "Event Manager"}</strong>
            </Text>
            <Text>
              <StrongBlue>C3ware Multi</StrongBlue>{" "}
              <StrongGreen>Call Technologies Pvt Ltd</StrongGreen>
            </Text>
            <Text>
              <StrongBlue>+91 44 66776600</StrongBlue>
              <Separator>|</Separator>
              <StrongGreen>+91 44 22540231</StrongGreen>
            </Text>
            <Text>
              <StrongBlue>events@multicall.in</StrongBlue>
              <Separator>|</Separator>
              <StrongGreen>customercare@dsnl.in</StrongGreen>
            </Text>
            <Image src={Images?.multicallLogo} alt="Company Logo" />
          </Column>
        </Content>
      </MainContainer>
      <SectionTitle style={{ backgroundColor: "#FF8383" }} green>
        MultiCall Internal Information
      </SectionTitle>
      <Content>
        <Column>
          <Text>
            <BoldText>Operator Name:</BoldText>{" "}
            {meta?.teamDetails?.operatorName || "-"}
          </Text>
          <Text>
            <BoldText>Streaming Engineer:</BoldText>{" "}
            {meta?.teamDetails?.streamingEngineer || "-"}
          </Text>
          <Text>
            <BoldText>Equipment Details:</BoldText>{" "}
            {meta?.teamDetails?.equipmentDetails || "-"}
          </Text>
        </Column>
        <Column>
          <Text>
            <BoldText>Onsite Person:</BoldText>{" "}
            {meta?.teamDetails?.onsitePerson || "-"}
          </Text>
          <Text>
            <BoldText>Equipment Vendor:</BoldText>{" "}
            {meta?.teamDetails?.equipmentVendor || "-"}
          </Text>
        </Column>
      </Content>
      <SectionTitle style={{ backgroundColor: "#FF8383" }} green>
        Live Stream Settings
      </SectionTitle>
      <StreamContainer>
        {meta?.liveStreamSettings.map((item, index) => (
          <Card key={index}>
            <LinksContainer>
              <BoldText>{item.label}: </BoldText>{" "}
              <span style={{ marginLeft: "3px" }}>Yes</span>
            </LinksContainer>
            {item?.primaryRtmpUrl && (
              <LinksContainer>
                <BoldText>RTMP Primary URL:</BoldText>
                <StyledLink
                  href={item.primaryRtmpUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.primaryRtmpUrl}
                </StyledLink>
              </LinksContainer>
            )}
            {item?.backupRtmpUrl && (
              <LinksContainer>
                <BoldText style={{ width: "auto" }}>RTMP Backup URL:</BoldText>
                <StyledLink
                  href={item.backupRtmpUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.backupRtmpUrl}
                </StyledLink>
              </LinksContainer>
            )}
            {item?.streamingKey && (
              <LinksContainer>
                <BoldText>Streaming Key:</BoldText>
                <span style={{ marginLeft: "3px" }}>{item.streamingKey}</span>
              </LinksContainer>
            )}
            {item?.liveStreamPlayerUrl && (
              <LinksContainer>
                <BoldText>Live Stream Player URL:</BoldText>
                <StyledLink
                  href={item.liveStreamPlayerUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.liveStreamPlayerUrl}
                </StyledLink>
              </LinksContainer>
            )}
            {item?.highAvailabilityLink && (
              <LinksContainer>
                <BoldText>High Availability URL:</BoldText>
                <StyledLink
                  href={item.highAvailabilityLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.highAvailabilityLink}
                </StyledLink>
              </LinksContainer>
            )}
          </Card>
        ))}
      </StreamContainer>

      <SectionTitle style={{ backgroundColor: "#FF8383" }} green>
        Special Instructions
      </SectionTitle>
      <SectionTitle style={{ backgroundColor: "#FF8383" }} green>
        Additional Information
      </SectionTitle>
    </Container>
  );
};

export default EventConfirmation;

const EmailWrapper = styled.table`
  width: 100%;
  border-collapse: collapse;
  padding: 10px;
`;

const EmailRow = styled.tr``;

const EmailCell = styled.td`
  width: 50%;
  padding: 10px;
  text-align: ${({ alignRight }) => (alignRight ? "right" : "left")};

  @media (max-width: 600px) {
    display: block;
    width: 100%;
    text-align: center;
  }
`;

const EmailLogo = styled.img`
  max-width: 150px;
  height: auto;
`;

const Container = styled.div`
  font-family: "Poppins", sans-serif;
  padding: 20px;
`;

const Header = styled.div`
  background-color: #005aa7;
  width: 100%;
  color: white;
  text-align: center;
  padding: 10px;
  font-size: 22px;
  font-weight: bold;
`;

const Section = styled.div`
  width: 100%;
  background-color: ${(props) => (props.green ? "#4CAF50" : "")};
  color: ${(props) => (props.green ? "white" : "black")};
  padding: 10px;
  font-weight: ${(props) => (props.green ? "bold" : "normal")};
  margin-top: 10px;
`;

const SectionTitle = styled.div`
  width: 100%;
  background-color: ${(props) => (props.green ? "#4CAF50" : "")};
  color: ${(props) => (props.green ? "white" : "black")};
  padding: 10px;
  font-weight: ${(props) => (props.green ? "bold" : "normal")};
  margin-top: 10px;
  text-align: center;
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  // background: white;
  padding: 15px;
  border-radius: 5px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Column = styled.div`
  width: 50%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const BoldText = styled.span`
  font-weight: bold;
`;

const TwoColumnSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 15px;
  border-radius: 5px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Text = styled.p`
  margin: 5px 0;
`;

const StrongBlue = styled.strong`
  color: #00aeef;
`;

const StrongGreen = styled.strong`
  color: #5cb338;
`;

const Separator = styled.span`
  margin: 0 8px;
  color: #333;
`;

const Image = styled.img`
  width: 174px;
  height: 60px;
  margin-top: 10px;
`;

const SpeakersContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 15px;
  font-family: "Poppins", sans-serif;
`;

const SpeakerCard = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

const SpeakerInfo = styled.div`
  flex: 1;
  p {
    margin: 0;
    font-size: 14px;
  }
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Input = styled.input`
  border-radius: 5px;
  padding: 5px;
  width: 250px;
  border: 1px solid #ccc;
`;

const StreamContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 10px;
  padding: 10px;
  font-family: "Poppins", sans-serif;
`;

const StyledLink = styled.a`
  color: #007bff;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 3px;
  &:hover {
    text-decoration: underline;
  }
`;

const Card = styled.div`
  border-radius: 8px;
  border: 1px solid #ccc;
  padding: 15px;
`;

const Row = styled.div`
  display: flex;
  margin-bottom: 5px;
  width: 100%;
`;

const MainContainer = styled.div`
  width: 100%;
  border-radius: 10px;
`;

const LinksContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
`;
